export const getInputClassCustomizedTextArea = (
    borderClass: string,
    errorLabel?: string,
    background?:string,
    readOnly?: boolean
) => {
 return `
    relative m-0 block w-[1px] min-w-0 flex-auto
    h-[44px]
    bg-[${background}] border border-[#B0B3BA] opacity-100 placeholder:text-red-500 disabled:opacity-50 
    ${borderClass} border border-solid 
    font-normal leading-[1.6] outline-none transition duration-200 ease-in-out focus:z-[3]  
    focus:outline-none focus:ring-1 focus:ring-[#9B0D78]  focus:border-[#B0B3BA] 
    ${errorLabel ? 'focus:border-red-500 focus:outline-none focus:ring-0 border-[#CA3532]' : 'border-[#B0B3BA]'}
    ${readOnly ? 'hover:border-transparent text-slate-500 focus:text-slate-500' : 'focus:border-[#002B6E] p-2 rounded-md'}
`;
};
export const getInputClassCustomized = (
    borderClass: string,
    errorLabel?: string,
    background?:string,
    readOnly?: boolean
) => {
 return `
    relative m-0 block w-[1px] min-w-0 flex-auto
    h-[44px]
    bg-[${background}] border border-[#B0B3BA] opacity-100 placeholder:text-[#6B6F7B] disabled:opacity-50 
    ${borderClass} border border-solid 
    font-normal leading-[1.6] outline-none transition duration-200 ease-in-out focus:z-[3]  
    focus:outline-none focus:ring-1 focus:ring-[#9B0D78]  focus:border-[#B0B3BA] 
    ${errorLabel ? 'focus:border-red-500 focus:outline-none focus:ring-0 border-[#CA3532]' : 'border-[#B0B3BA]'}
    ${readOnly ? 'hover:border-transparent text-slate-500 focus:text-slate-500' : 'focus:border-[#002B6E] p-2 rounded-md'}
`;
};

export const getInputClass = (
    borderClass: string,
    errorLabel?: string,
    readOnly?: boolean
) => {
    return `text-sm relative m-0 block w-[1px] min-w-0 flex-auto 
        p-2 pl-1.5
        ${borderClass} border border-solid 
        font-normal leading-[1.6] outline-none transition duration-200 ease-in-out focus:z-[3]  
        focus:text-neutral-700 focus:ring-1 ${
            errorLabel
                ? 'focus:ring-custom-error border-custom-error'
                : 'focus:ring-custom-violet border-custom-light-gray'
        } focus:border-1-[#fff] focus:outline-none focus:border-solid
        disabled:bg-[#F1F3FB] disabled:border-1 disabled:border-[#D9D9D9] disabled:text-[#D9D9D9]
        ${readOnly ? 'hover:border-transparent text-slate-500 focus:text-slate-500' : 'hover:border-1 hover:border-dashed'}
    `;
};

function getInputClassFile(errors:any, isDragActive: boolean): string {
  return `cursor-pointer w-auto h-[120px] top-[138px] left-[16px]
          pt-4 pb-0 gap-2 rounded-l-md border
          bg-[#F5F5F5] flex items-center
          ${errors.script ? 'border-error' : 'border-[#CED0D5]'}
          px-5 py-5 ${!isDragActive ? 'border' : 'border-Foundation/Primary-Dark'}`;
}

export const fontWeightClass = (fontWeight:string) => {
  return fontWeight === 'bold'
    ? 'font-bold'
    : fontWeight === 'extrabold'
    ? 'font-extrabold'
    : 'font-normal';
};
export default getInputClassFile

export const labelClass = "flex justify-center font-arial text-[16px] font-normal leading-[28px] text-center"
